module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-music-fill-64cdbd23.svg";